import { useLanguage } from "../i18n/LanguageContext";
import { useTheme } from "../theme/ThemeContext";

interface Props {
  /**
   * "dark" = ink on the page surface (flips to the cream mark in dark mode);
   * "light" = always the cream mark, for espresso/bordeaux surfaces.
   */
  tone?: "dark" | "light";
  /** The script alone, or the full lockup with "Café — Bar". */
  variant?: "wordmark" | "lockup";
  height?: number;
  className?: string;
}

/**
 * The handwritten mark, cut from the brand sheet. Rule 02 of the brand:
 * the script is an accent, never body copy — so it is always an image with
 * a proper alt, never a font.
 */
export default function Logo({ tone = "dark", variant = "wordmark", height = 34, className }: Props) {
  const { t } = useLanguage();
  const { theme } = useTheme();
  const resolved = tone === "dark" && theme === "dark" ? "light" : tone;
  const src = `/brand/${variant}-${resolved}.png`;
  const alt = variant === "lockup" ? `${t("brand")} — ${t("brandSub")} · ${t("brandLine")}` : t("brand");
  return <img className={className} src={src} alt={alt} style={{ height, width: "auto" }} draggable={false} />;
}
